import React from "react";
import {Helmet} from "react-helmet";
import {useEnvironment} from "../../hooks/UseEnvironment";
import _image_service from "../../services/ImageService";

interface PageActionProps {
    title: string,
    description: string,
    keywords: string[],
    url: string,
    imgSrc: string
}

class PageActions {

    private readonly _target_client = useEnvironment().targetClient;

    private static readonly _common_keywords: string[] = ["chase the fox", "furry", "furry art",
        "furry oc", "furry streamer", "furry artist", "furry website", "chasetheredfox"];

    private readonly props: PageActionProps;

    constructor(props: PageActionProps) {
        this.props = props;
    }

    public getTitle(): string {
        return this.props.title;
    }

    public getDescription(): string {
        return this.props.description;
    }

    public getKeywords(): string {
        return PageActions._common_keywords.concat(this.props.keywords).filter(keyword => keyword).join(',');
    }

    public getUrl(): string {
        return this.props.url;
    }

    public getFullUrl(): string {
        let fullUrl = this.props.url;
        if (!fullUrl.startsWith(this._target_client)) {
            fullUrl = this._target_client + ((fullUrl.startsWith('/')) ? fullUrl.substring(1) : fullUrl);
        }

        return fullUrl;
    }

    public getImgSrc(): string {
        return _image_service.getCdnImageSrc(this.props.imgSrc, 'thumbnail');
    }

    // TODO: Make generalized for different site pages
    private getRssFeed(): string {
        return `${this._target_client.endsWith('/')
            ? this._target_client
            : this._target_client + '/'}v1/rss/feeds/chase`;
    }

    public generateMetaContent(pageContent: JSX.Element): JSX.Element {
        return (
            <>
                <Helmet>
                    <title>{this.getTitle()}</title>
                    <link rel="alternate" type="application/rss+xml" title="Chase's Site Updates" href={this.getRssFeed()}/>
                    <link id="canonical-link" rel="canonical" href={this.getFullUrl()}/>
                    <meta name="description" property="description" content={this.getDescription()}/>
                    <meta name="keywords" property="keywords" content={this.getKeywords()}/>
                    <meta name="title" property="title" content={this.getTitle()}/>
                    <meta property="og:url" content={this.getFullUrl()}/>
                    <meta property="og:site_name" content="Chase the Fox"/>
                    <meta property="og:title" content={this.getTitle()}/>
                    <meta property="og:type" content="website"/>
                    <meta property="og:image" content={this.getImgSrc()}/>
                    <meta property="og:description" content={this.getDescription()}/>
                    <meta name="twitter:card" content="summary"/>
                    <meta name="twitter:creator" content="@ChaseTheRedFox"/>
                    <meta name="twitter:title" content={this.getTitle()}/>
                    <meta name="twitter:image" content={this.getImgSrc()}/>
                    <meta name="twitter:description" content={this.getDescription()}/>
                </Helmet>
                {pageContent}
            </>
        );
    }
}

export default PageActions;